import React from 'react';
import styled from 'styled-components';

const ButtonBottomDiv = styled.div`
  position: absolute;
  width: 80vw;
  display: flex;
  justify-content: center;
  bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
`;

const ButtonGridDiv = styled.div`
  grid-area: ${(p) => p.grid};
  box-sizing: border-box;
  width: 100%;
  height: 2.5rem;
`;

const SimpleDiv = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 3rem;
`;

const StyledButton = styled.button`
  font-size: 1.1rem;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  border: ${(p) => `2px ${p.theme.primary} solid`};
  margin: 0;
  text-decoration: none;
  cursor: pointer;
  text-align: center;
  background-color: ${(p) => (p.filled ? p.theme.primary : p.theme.light)};
  color: ${(p) => (p.filled ? 'white' : p.theme.primary)};
  &:disabled{
    color:#fff;
    border-color: #a0a0a0;
    background-color: #a0a0a0;
    cursor: not-allowed;
  }
`;


function Button({ onClick, filled, bottom, grid, children, disabled }) {
  if (bottom) {
    return (
      <ButtonBottomDiv>
        <StyledButton onClick={onClick} filled={filled}>
          {children}
        </StyledButton>
      </ButtonBottomDiv>
    );
  } else if (grid) {
    return (
      <ButtonGridDiv >
        <StyledButton onClick={onClick} filled={filled} disabled={disabled}>
          {children}
        </StyledButton>
      </ButtonGridDiv>
    );
  } else {
    return (
      <SimpleDiv>
        <StyledButton onClick={onClick} filled={filled}>
          {children}
        </StyledButton>
      </SimpleDiv>
    );
  }
}

export default Button;
